/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type UcDeptTreeNode } from '@coze-foundation/account-adapter';

export function collectDeptNodesByIds(
  nodes: UcDeptTreeNode[],
  ids: string[],
): UcDeptTreeNode[] {
  const idSet = new Set(ids);
  const out: UcDeptTreeNode[] = [];
  const walk = (list: UcDeptTreeNode[]) => {
    for (const node of list) {
      if (idSet.has(node.departmentId)) {
        out.push(node);
      }
      if (node.children?.length) {
        walk(node.children);
      }
    }
  };
  walk(nodes);
  return out;
}
